import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useAuth } from "../../../../context/AuthContext";
// import {
//   useStripe,
//   useElements,
//   PaymentElement,
// } from "@stripe/react-stripe-js";
import { useStateContext } from "../../../../context/StateContext_KO";
import { useTranslation } from "react-i18next";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import FormGroup from "@mui/material/FormGroup";
import agreement from "./agreement.txt";
import agreement2 from "./agreement2.txt";
import Modal from "@mui/material/Modal";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";

function BpCheckbox(props) {
  return (
    <Checkbox
      sx={{
        "&:hover": { bgcolor: "transparent" },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      inputProps={{ "aria-label": "Checkbox demo" }}
      {...props}
    />
  );
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid white",
  boxShadow: 24,
  p: 4,
};

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: "50%",
  width: 16,
  height: 16,
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 0 0 1px rgb(16 22 26 / 40%)"
      : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
  backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
  backgroundImage:
    theme.palette.mode === "dark"
      ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
      : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  ".Mui-focusVisible &": {
    outline: "2px auto rgba(19,124,189,.6)",
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background:
      theme.palette.mode === "dark"
        ? "rgba(57,75,89,.5)"
        : "rgba(206,217,224,.5)",
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#137cbd",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    display: "block",
    width: 16,
    height: 16,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: "#106ba3",
  },
});

export default function EnterPayment(props) {
  let navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const { t, i18n } = useTranslation();
  // console.log(window.location.origin + "/success");
  // const stripe = useStripe();
  // const elements = useElements();
  const [error, setError] = useState("");
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { currentUser } = useAuth();
  const { basket, getBasketTotal } = useStateContext();

  const [paymentOption, setPaymentOption] = useState(null);

  const [text, setText] = useState("");
  const [text2, setText2] = useState("");
  const [open, setOpen] = useState(false);

  const [agree, setAgree] = useState(false);
  console.log(agree);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => {
    setOpen2(true);
  };
  const handleClose2 = () => setOpen2(false);

  useEffect(() => {
    fetch(agreement)
      .then((response) => response.text())
      .then((textContent) => {
        setText(textContent);
      });
    fetch(agreement2)
      .then((response) => response.text())
      .then((textContent) => {
        setText2(textContent);
      });
  }, []);

  let address =
    props.shippingAddress.lastname +
    " " +
    props.shippingAddress.firstname +
    " - " +
    props.shippingAddress.address +
    " " +
    props.shippingAddress.apt +
    " " +
    // props.shippingAddress.city +
    // " " +
    // props.shippingAddress.state +
    " " +
    props.shippingAddress.zipcode;

  // useEffect(() => {
  //   if (!stripe) {
  //     return;
  //   }

  //   const clientSecret = new URLSearchParams(window.location.search).get(
  //     "payment_intent_client_secret"
  //   );
  //   console.log("clientSecret", clientSecret);

  //   if (!clientSecret) {
  //     return;
  //   }

  //   stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
  //     console.log(paymentIntent.status);
  //     switch (paymentIntent.status) {
  //       case "succeeded":
  //         setMessage("Payment succeeded!");
  //         break;
  //       case "processing":
  //         setMessage("Your payment is processing.");
  //         break;
  //       case "requires_payment_method":
  //         setMessage("Your payment was not successful, please try again.");
  //         break;
  //       default:
  //         setMessage("Something went wrong.");
  //         break;
  //     }
  //     setIsLoading(false);
  //   });
  // }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (paymentOption === "Deposit without bankbook") {
      if (e.target.bank_name.value && e.target.bank_name.value.length > 0) {
        if (
          e.target.bank_customer_name.value &&
          e.target.bank_customer_name.value.length > 0
        ) {
          // alert(e.target.bank_customer_name.value);
          // info
          sessionStorage.setItem("FinishCheckoutKorea", true);
          sessionStorage.setItem("paymentOption", "Deposit without bankbook");
          sessionStorage.setItem("bank", e.target.bank_name.value);
          sessionStorage.setItem(
            "customer_name",
            e.target.bank_customer_name.value
          );
          navigate(`/success_ko`);
        } else {
          setIsLoading(false);
          setError(t("Please put your name"));
        }
      } else {
        setIsLoading(false);
        setError(t("Please select a bank"));
      }
    }

    // if (!stripe || !elements) {
    //   setIsLoading(false);
    //   return;
    // }
    // const result = await stripe.confirmPayment({
    //   elements,
    //   confirmParams: {
    //     return_url: window.location.origin + "/success_ko",
    //   },
    // });

    // if (result.error) {
    //   setIsLoading(false);
    //   setError(result.error.message);
    // } else {
    // }
  };

  let show;

  // if (paymentOption === "international") {
  //   show = <PaymentElement id="payment-element" />;
  // } else

  if (paymentOption === "Deposit without bankbook") {
    show = (
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ width: "80px" }}>
            입금 은행
            <span style={{ color: "#73a2f1", fontSize: "23px" }}>*</span>
          </Box>
          <select
            name="bank_name"
            style={{
              width: "60%",
              height: "50px",
              marginLeft: "10px",
              padding: "12px",
            }}
          >
            <option value="">** 선택해주세요 **</option>
            <option value="농협:283-3433-3243-83 장명기">
              농협:283-3433-3243-83 장명기
            </option>
          </select>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", pt: 2 }}>
          <Box sx={{ width: "90px" }}>
            입금자명
            <span style={{ color: "#73a2f1", fontSize: "23px" }}>*</span>
          </Box>
          <input
            type="input"
            name="bank_customer_name"
            style={{ border: "1px solid #7a7a7a" }}
          />
        </Box>
        <Box
          sx={{ pt: 3, lineHeight: "180%", color: "#424242", fontSize: "12px" }}
        >
          전용 계좌번호 발급으로 입금인 명의와 상관없이 입금 가능합니다. (
          예금주 : 주식회사 헤즐릿 ) <br />
          입금액과 결제 금액이 일치해야 정상 입금완료되니{" "}
          <strong>금액을 반드시 확인바랍니다.</strong> <br />
          배송은 입금완료를 기준으로 처리되며, 미입금 상태에서 주문한 상품이
          품절될 경우 입금하셔도 배송이 불가합니다. <br />
          입금기한은 주문완료 후 3일 이내이며, 미입금 시 자동 취소 됩니다.
        </Box>
      </Box>
    );
  } else if (paymentOption === "Escrow") {
    show = (
      <Box>
        <FormGroup>
          <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
            <Box sx={{ mr: 2 }}>
              예금주명
              <span style={{ color: "#73a2f1", fontSize: "23px" }}>*</span>
            </Box>
            <Box>
              <input type="input" style={{ border: "1px solid #7a7a7a" }} />
            </Box>
          </Box>
          <Box sx={{ px: 2, color: "#7a7a7a" }}>
            <FormControlLabel
              control={<Checkbox defaultChecked />}
              label="에스크로(구매안전) 서비스를 적용합니다."
            />
          </Box>
        </FormGroup>
      </Box>
    );
  } else {
    show = <Box></Box>;
  }

  return (
    <Box sx={{ pt: 7, px: 7, mb: 30, fontSize: "12px" }}>
      <Box
        sx={{
          display: "flex",
          width: 1,
          borderBottom: "1px solid lightgray",
          paddingBottom: "10px",
        }}
      >
        <Box sx={{ pr: 4, width: "60px" }}>{t("email")}</Box>
        <Box sx={{ color: "#616161", fontWeight: "bold" }}>{props.email}</Box>
        <Box
          sx={{
            fontSize: "14px",
            color: "gray",
            marginLeft: "auto",
            textDecoration: "underline",
            cursor: "pointer",
            fontSize: "12px",
          }}
          onClick={() => props.goToFirstStep()}
        >
          {t("edit")}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          width: 1,
          borderBottom: "1px solid lightgray",
          paddingBottom: "10px",
          paddingTop: "10px",
          fontSize: "15px",
        }}
      >
        <Box sx={{ pr: 4, width: "60px", fontSize: "12px" }}>
          {t("Address")}
        </Box>
        <Box sx={{ color: "#616161", fontWeight: "bold", fontSize: "12px" }}>
          {address}
        </Box>
        <Box
          sx={{
            fontSize: "14px",
            color: "gray",
            marginLeft: "auto",
            textDecoration: "underline",
            cursor: "pointer",
            fontSize: "12px",
          }}
          onClick={() => props.goToStepTwo()}
        >
          {t("edit")}
        </Box>
      </Box>
      {/* <Box
        sx={{
          display: "flex",
          width: 1,
          borderBottom: "1px solid lightgray",
          paddingBottom: "10px",
          paddingTop: "10px",
          fontSize: "15px",
        }}
      >
        <Box sx={{ pr: 4, width: "60px" }}>{t("Shipping")}</Box>
        <Box sx={{ color: "#616161", fontWeight: "bold" }}>
          {props.shipping}
        </Box>
        <Box
          sx={{
            fontSize: "14px",
            color: "gray",
            marginLeft: "auto",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => props.goToPreviousStep()}
        >
          {t("edit")}
        </Box>
      </Box> */}
      <form
        id="payment-form"
        onSubmit={handleSubmit}
        style={{ paddingTop: "40px" }}
      >
        <Box sx={{ pb: 1, fontSize: "16px", fontWeight: 600 }}>
          {t("Card Payment")}
        </Box>

        <Box
          sx={{
            border: "1px solid #a8c5f6",
            mt: 2,
          }}
        >
          <Box
            sx={{
              borderBottom: "1px solid #dce4ee",
              backgroundColor: "#eef1f4",
            }}
          >
            <Box sx={{ px: 3, py: 2, fontWeight: 600 }}>결제 수단 선택</Box>
          </Box>
          <Box sx={{ px: 3, py: 1 }}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel
                  value="Card"
                  control={
                    <Radio
                      sx={{
                        "&:hover": {
                          bgcolor: "transparent",
                        },
                      }}
                      disableRipple
                      color="default"
                      checkedIcon={<BpCheckedIcon />}
                      icon={<BpIcon />}
                      onClick={(e) => setPaymentOption(e.target.value)}
                    />
                  }
                  label="카드 결제"
                />
                <FormControlLabel
                  value="Escrow"
                  control={
                    <Radio
                      sx={{
                        "&:hover": {
                          bgcolor: "transparent",
                        },
                      }}
                      disableRipple
                      color="default"
                      checkedIcon={<BpCheckedIcon />}
                      icon={<BpIcon />}
                      onClick={(e) => setPaymentOption(e.target.value)}
                    />
                  }
                  label="에스크로(실시간 계좌이체)"
                />
                {/* 무통장 */}
                <FormControlLabel
                  value="Deposit without bankbook"
                  control={
                    <Radio
                      sx={{
                        "&:hover": {
                          bgcolor: "transparent",
                        },
                      }}
                      disableRipple
                      color="default"
                      checkedIcon={<BpCheckedIcon />}
                      icon={<BpIcon />}
                      onClick={(e) => setPaymentOption(e.target.value)}
                    />
                  }
                  label="무통장 입금"
                />
                <FormControlLabel
                  value="Escrow virtual"
                  control={
                    <Radio
                      sx={{
                        "&:hover": {
                          bgcolor: "transparent",
                        },
                      }}
                      disableRipple
                      color="default"
                      checkedIcon={<BpCheckedIcon />}
                      icon={<BpIcon />}
                      onClick={(e) => setPaymentOption(e.target.value)}
                    />
                  }
                  label="에스크로(가상계좌)"
                />{" "}
                {/* <FormControlLabel
                  value="international"
                  control={
                    <Radio
                      sx={{
                        "&:hover": {
                          bgcolor: "transparent",
                        },
                      }}
                      disableRipple
                      color="default"
                      checkedIcon={<BpCheckedIcon />}
                      icon={<BpIcon />}
                    />
                  }
                  label="International (Stripe)"
                  onClick={(e) => setPaymentOption(e.target.value)}
                /> */}
              </RadioGroup>
            </FormControl>
          </Box>
        </Box>

        {error && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}

        <Box sx={{ pt: 3 }}>{show}</Box>

        <Box sx={{ border: "1px solid lightgray", mt: 1 }}>
          <Box sx={{ borderBottom: "1px solid lightgray" }}>
            <Box sx={{ px: 2, py: 1 }}>
              <FormControlLabel
                control={
                  <BpCheckbox value={agree} onClick={() => setAgree(!agree)} />
                }
                label="모든 약관 동의"
              />
            </Box>
          </Box>
          <Box sx={{ p: 2, lineHeight: "180%", px: 3 }}>
            {/* <Box>
              <span style={{ color: "#73a2f1" }}>[필수]</span> 구매조건 확인 및
              결제진행 동의{" "}
              <span style={{ color: "#3f51b5", cursor: "pointer" }}>
                [열어보기]
              </span>
            </Box> */}
            <Box>
              <span style={{ color: "#73a2f1" }}>[필수]</span> 쇼핑몰 이용약관
              동의{" "}
              <span
                onClick={() => handleOpen()}
                style={{ color: "#3f51b5", cursor: "pointer" }}
              >
                [열어보기]
              </span>
            </Box>
            <Box>
              <span style={{ color: "#73a2f1" }}>[필수]</span> 비회원 구매시
              개인정보 처리방침 동의{" "}
              <span
                onClick={() => handleOpen2()}
                style={{ color: "#3f51b5", cursor: "pointer" }}
              >
                [열어보기]
              </span>
            </Box>
          </Box>
        </Box>
        <button
          className="custom_btn"
          disabled={!agree || isLoading}
          style={{
            backgroundColor: !agree || isLoading ? "lightgray" : null,
            color: !agree ? "black" : null,
            marginTop: "20px",
          }}
          id="submit"
        >
          <span id="button-text">
            {isLoading ? <div>...{t("Processing")}</div> : t("Pay now")}
          </span>
        </button>
        {/* Show any error or success messages */}
        {/* {message && <div id="payment-message">{message}</div>} */}
      </form>{" "}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            sx={{ fontSize: "12px", overflow: "scroll", height: "400px" }}
          >
            <Typography dangerouslySetInnerHTML={{ __html: text }} />
          </Typography>

          <button
            onClick={handleClose}
            style={{ marginTop: "10px" }}
            className="custom_btn"
          >
            닫기
          </button>
        </Box>
      </Modal>
      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            sx={{ fontSize: "12px", overflow: "scroll", height: "400px" }}
          >
            <Typography dangerouslySetInnerHTML={{ __html: text2 }} />
          </Typography>

          <button
            onClick={handleClose2}
            style={{ marginTop: "10px" }}
            className="custom_btn"
          >
            닫기
          </button>
        </Box>
      </Modal>
    </Box>
  );
}
